<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="线路" prop="circuitId">
            <el-select clearable v-model="queryParams.circuitId" placeholder="请选择线路进行查询">
              <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
                :value="item.circuitId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select clearable v-model="queryParams.type" placeholder="请选择类型">
              <el-option v-for="item in systemModelList" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn-boxs">
            <div></div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name" :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->

            <span v-if="tab.code === 'type'">{{ scope.row[tab.code] + 'C' }}</span>
            <span v-else-if="tab.code === 'pictureTime'">
              <i class="el-icon-time"></i>
              <span style="margin-left:5px">{{ scope.row.pictureTime }}</span>
            </span>
            <span v-else-if="tab.code === 'viewPic'">
              <el-image v-if="scope.row.viewPic !== '0'" :src="scope.row.viewPic"
                :preview-src-list="[scope.row.viewPic]" fit="cover" alt="图片展示" style="width: 80px; height: 80px;" />
            </span>
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button
              style="color:red"
              type="text"
              @click="deleteData(scope.row)"
              class="update-btn"
            >删除</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisble" width="40%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="线路" prop="circuitId">
          <el-select v-model="form.circuitId" placeholder="请选择线路" @change="circuitChange">
            <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
              :value="item.circuitId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区站" prop="stationId" v-if="form.circuitId">
          <el-select v-model="form.stationId" placeholder="请选择区站">
            <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
              :value="item.stationId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支柱" prop="pillarId">
          <el-select v-model="form.pillarId" placeholder="请选择支柱">
            <el-option v-for="item in pillarList" :key="item.pillarId" :label="item.pillarNum"
              :value="item.pillarId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部件设备" prop="componentId">
          <el-select v-model="form.componentId" placeholder="请选择部件设备">
            <el-option v-for="item in componentList" :key="item.componentId" :label="item.componentName"
              :value="item.componentId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option label="1C" value="1"></el-option>
            <el-option label="2C" value="2"></el-option>
            <el-option label="3C" value="3"></el-option>
            <el-option label="4C" value="4"></el-option>
            <el-option label="5C" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片时间" prop="pillarTime">
          <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.pillarTime"
            type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="图片文件名称" prop="pictureName">
          <el-input maxlength="7" show-word-limit v-model="form.pictureName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片文件路径" prop="picturePath">
          <el-input v-model="form.picturePath" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getPictureList, pictureAdd,pictureById, updetePicture,deletePicture} from "@/api/document-service/picture.js";
import { getApparatusAll } from "@/api/data-service/apparatus.js";
import { getComponentAll } from "@/api/data-service/unit.js";
import { getPillarAll } from "@/api/data-service/pillar.js";
import { getStationAll } from "@/api/data-service/station.js";
import { getCircuitAll } from "@/api/data-service/line.js";
import { getSystemModel } from "@/api/admin-service/dictDataType.js";

export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        componentId: "",
        pillarId: "",
        type: "",
        pillarTime: "",
        pictureName: "",
        picturePath: "",
        stationId: "", //区站id
        circuitId: "" //线路id
      },
      rules: {
        pillarId: [
          { required: true, message: "请选择支柱", trigger: "change" }
        ],
        componentId: [
          { required: true, message: "请选择部件设备", trigger: "change" }
        ],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        pillarTime: [
          { required: true, message: "请填写图片时间", trigger: "blur" }
        ],
        pictureName: [
          { required: true, message: "请填写图片名称", trigger: "blur" }
        ],
        picturePath: [
          { required: true, message: "请填写图片路径", trigger: "blur" }
        ],
        stationId: [{ required: true, message: "请选择区站", trigger: "blur" }],
        circuitId: [{ required: true, message: "请选择线路", trigger: "blur" }]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "线路", code: "circuitName", width: "" },
        { name: "区站", code: "stationName", width: "" },
        { name: "支柱", code: "pillarNum", width: "" },
        { name: "部件设备", code: "componentName", width: "" },
        { name: "类型", code: "type", width: "" },
        { name: "图片时间", code: "pictureTime", width: "" },
        { name: "图片名称", code: "pictureName", width: "" },
        { name: "图片路径", code: "picturePath", width: "" },
        { name: "图片", code: "viewPic", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        // pillarId: 0,
        // componentId: 0,
        type: ""
      },
      apparatusList: [],
      componentList: [],
      pillarList: [],
      stationList: [],
      circuitList: [],
      systemModelList: []
    };
  },
  mounted() {
    this.onGetDataList();
    // this.queryApparatusList();
    // this.queryComponentList(); //查询部件枚举
    // this.queryPillarList(); //查询支柱枚举
    // this.queryStaionList();
    this.queryCircuitList();
    this.getSystemModel();
  },

  methods: {
    getSystemModel() {
      getSystemModel({ type: "sys_model_type" }).then(res => {
        this.systemModelList = res?.data || [];
      });
    },

    // 这个方法会在选择线路发生变化时被调用
    circuitChange(newValue) {
      this.form.stationId = "";
      this.queryStaionList(newValue);
    },
    queryComponentList() {
      getComponentAll({
        componentName: "",
        ...this.pageParams
      }).then(res => {
        this.componentList = res?.data || [];
      });
    },
    queryPillarList() {
      getPillarAll({
        remark: "",
        pillarNum: "", //	支柱编号
        kilometerSign: "", // 	公里标
        ...this.pageParams
      }).then(res => {
        this.pillarList = res?.data || [];
      });
    },
    queryApparatusList() {
      getApparatusAll({
        apparatusName: "",
        ...this.pageParams
      }).then(res => {
        this.apparatusList = res?.data || [];
      });
    },
    queryStaionList(circuitId) {
      getStationAll({
        stationName: "", //区站名称
        circuitId,
        ...this.pageParams
      }).then(res => {
        this.stationList = res?.data || [];
      });
    },
    queryCircuitList() {
      getCircuitAll({
        circuitName: "", //线路名称
        ...this.pageParams
      }).then(res => {
        this.circuitList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.pictureId; // 清除 defectReportId
            pictureAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updetePicture({
              ...this.form,
              pictureId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deletePicture({ ids: [row.pictureId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.pictureId;
      pictureById({ id: row.pictureId }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getPictureList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          const typeMaping = {
            "1": process.env.VUE_APP_SOURCE8,
            "2": process.env.VUE_APP_SOURCE2,
            "4": process.env.VUE_APP_SOURCE4,
          };
          this.tableData = records.map(item => {
            return {
              ...item,
              viewPic: typeMaping[item.type] + item.picturePath
            };
          });
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlepictureAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      Object.keys(this.queryParams).forEach(key => {
        this.queryParams[key] = ""; // 你可以根据需要调整重置的值（例如：'' 或者 null）
      });
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
